import { SearchAdapter } from '@empathy/search-adapter';
import { Result } from '@empathy/search-types';
import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { TRACKING_ACTIONS_KEYS } from '../tracking.const';
import { TrackingAction } from '../tracking.interfaces';

export class TrackPendingUrlClickAction implements TrackingAction {

  private adapter: SearchAdapter;
  private storageService: StorageService;

  actions = {
    [TRACKING_ACTIONS_KEYS.trackPendingURLClick]: () => {
      this.initDependencies();
      const url = window.location.href;
      const item = this.storageService.removeItem<Result>(url);
      if (item?.tagging?.click) {
        return this.adapter.track(item.tagging.click);
      }
    }
  };

  private initDependencies() {
    this.adapter = container.get<SearchAdapter>(DEPENDENCIES.Adapter);
    this.storageService = container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
  }
}
